<template>
  <v-text-field
    hide-details
    @input="updateValue($event)"
    :placeholder="placeholder"
    :type="type"
    outlined
  ></v-text-field>
</template>

<script>
export default {
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
</style>